import CommentView from '@ckeditor/ckeditor5-comments/src/comments/ui/view/commentview';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import * as _ from "lodash-es";

import Approve from './icons/Approve.svg';
import Reject from './icons/Reject.svg';
import Resolve from './icons/Resolve.svg';
import Delete from './icons/Delete.svg';
import Edit from './icons/Edit.svg';
import { CkeditorConstants } from "../../src/utils/ckeditorconstants";

const {
  class: { ck_button },
  commentLabels: { DELETE, EDIT },
  event: { EXECUTE }
} = CkeditorConstants;
export default class CustomCommentView extends CommentView {

  constructor(...args) {
    super(...args);
    this.bind(CkeditorConstants.commentAttributes.APPROVE).to(this._model, CkeditorConstants.commentAttributes.ATTRIBUTES, attributes => !!attributes.approve);
    this.bind(CkeditorConstants.commentAttributes.DRAFT).to(this._model, CkeditorConstants.commentAttributes.ATTRIBUTES, attributes => !!attributes.draft);
    this.bind(CkeditorConstants.commentAttributes.REJECT).to(this._model, CkeditorConstants.commentAttributes.ATTRIBUTES, attributes => !!attributes.reject);
    this.bind(CkeditorConstants.commentAttributes.RESOLVE).to(this._model, CkeditorConstants.commentAttributes.ATTRIBUTES, attributes => !!attributes.resolve);
    this.bind(CkeditorConstants.commentAttributes.STATUS).to(this._model, CkeditorConstants.commentAttributes.ATTRIBUTES, attributes => !!attributes.status);
    this.bind(CkeditorConstants.commentAttributes.TIMESTAMP).to(this._model, CkeditorConstants.commentAttributes.ATTRIBUTES, attributes => !!attributes.timestamp);
    this.bind(CkeditorConstants.commentAttributes.USERNAME).to(this._model, CkeditorConstants.commentAttributes.ATTRIBUTES, attributes => !!attributes.username);
  }

  getTemplate() {
    const templateDefinition = super.getTemplate();
    const buttonArr = this._createImportantButtonView(templateDefinition);
    const buttonForEditAndRemove = this._createEditAndRemoveButtonView();
    const data = this.getStatusMessage(templateDefinition);
    templateDefinition.children.unshift(data);
    this.isEditModeOn(templateDefinition);
    const trackChangesAndCommentsData = JSON.parse(localStorage.getItem(CkeditorConstants.localStorageItem.trackchangesandcommentsdata));
    const templateForButton = {
      tag: CkeditorConstants.htmlElement.SPAN,
      attributes: {
        class: CkeditorConstants.class.ckButtonContainer_ckComment_ckAnnotation,
      },
      children: []
    }
    templateForButton.children = buttonArr.map(btn => btn);
    templateDefinition.children.push(templateForButton);

    buttonForEditAndRemove[0].on(EXECUTE, () => {
      this.editButton.fire(EXECUTE);
    });

    buttonForEditAndRemove[1].on(EXECUTE, () => {
      this.removeButton.fire(EXECUTE);
    });

    templateDefinition.children[1]?.children[1]?.children[1]?.children?._items.push(...buttonForEditAndRemove);
    //buttons on load
    if (trackChangesAndCommentsData.commentThreads && trackChangesAndCommentsData.commentThreads.length > 0) {
      trackChangesAndCommentsData.commentThreads.forEach((thread) => {
        thread.comments.forEach(value => {
          if (value.attributes && (value.attributes.status === CkeditorConstants.commentAttributes.APPROVE || value.attributes.status === CkeditorConstants.commentAttributes.REJECT)) {
            if (value.commentId === templateDefinition.children[1].attributes[CkeditorConstants.helperAttributes.DATA_COMMENT_ID]) {
              templateDefinition.children[2].children.forEach((elm) => {
                if (elm.label === CkeditorConstants.commentLabels.APPROVE || elm.label === CkeditorConstants.commentLabels.REJECT) {
                  // Only keep the resolve button, remove approve and reject buttons
                    if (templateDefinition.children[2] && Array.isArray(templateDefinition.children[2].children)) {
                    templateDefinition.children[2].children = templateDefinition.children[2].children.filter(
                      btn => btn.class === 'ck-button-resolve'
                    );
                    }
                }
              })
            }
          }
        });
      },
      );
    }

    //Get status after save close n open document
    if (this._model.attributes && this._model.attributes.timestamp && this._model.attributes.username && (this._model.attributes.status === CkeditorConstants.commentAttributes.APPROVE || this._model.attributes.status === CkeditorConstants.commentAttributes.REJECT)) {
      templateDefinition.children[0].attributes.style.display = CkeditorConstants.style.block;
      if (this._model.attributes.timestamp && this._model.attributes.username) {
        const value = this._model.attributes.status === CkeditorConstants.commentAttributes.APPROVE ? CkeditorConstants.commentLabels.APPROVED : CkeditorConstants.commentLabels.REJECTED
        templateDefinition.children[0].children.push(`${value} by ${this._model.attributes.username} ${this._config.formatDateTime(this._model.attributes.timestamp)}`);
      }
    }
    return templateDefinition;
  }

  _createImportantButtonView(templateDefinition) {
    const buttonUiConfig = [
      { text: CkeditorConstants.commentLabels.REJECT, icon: Reject, isEnable: true },
      { text: CkeditorConstants.commentLabels.RESOLVE, icon: Resolve, isEnable: true },
      { text: CkeditorConstants.commentLabels.APPROVE, icon: Approve, isEnable: true }
    ];

    const buttons = [];
    buttonUiConfig.forEach((buttonConfig) => {

      const button = new ButtonView(this.locale);
      const t = this.locale.t;

      button.set({
        label: buttonConfig.text,
        class: CkeditorConstants.class.ck_button + buttonConfig.text.toLowerCase(),
        tooltip: t(buttonConfig.text + ' ' + CkeditorConstants.tooltip.COMMENT),
        withText: true,
        isEnabled: buttonConfig.isEnable
      });
      button.on(CkeditorConstants.event.EXECUTE, () => {
        const btnName = buttonConfig.text.toLowerCase();
        this._model.setAttribute(CkeditorConstants.commentAttributes.STATUS, btnName);
        if (btnName === CkeditorConstants.commentAttributes.APPROVE || btnName === CkeditorConstants.commentAttributes.REJECT) {
          this.saveBtnClick(btnName, templateDefinition);
        }
      });
      buttons.push(button)
    });

    return buttons;
  }

  saveBtnClick(btnName, templateDefinition) {
    const commentId = templateDefinition.children[1].attributes[CkeditorConstants.helperAttributes.DATA_COMMENT_ID]
    templateDefinition.children[2].children.forEach((elm) => {
      if (elm.element !== null) {
        if (elm.class === CkeditorConstants.class.ck_button_approve) {
          const approveButton = elm.element;
          approveButton.style.display = CkeditorConstants.style.none;
        } else if (elm.class === CkeditorConstants.class.ck_button_reject) {
          const rejectButton = elm.element;
          rejectButton.style.display = CkeditorConstants.style.none;
        }
      }
    })

    //Add status on click of approve or reject
    const currentUserData = JSON.parse(localStorage.getItem(CkeditorConstants.localStorageItem.currentUser));
    this._model.setAttribute(CkeditorConstants.commentAttributes.TIMESTAMP, new Date());
    this._model.setAttribute(CkeditorConstants.commentAttributes.USERNAME, currentUserData.name);
    const pEle = document.querySelector(`[data-status-id='${commentId}']`);
    pEle.style.display = CkeditorConstants.style.block;
    const value = (btnName === CkeditorConstants.commentAttributes.APPROVE) ? CkeditorConstants.commentLabels.APPROVED : CkeditorConstants.commentLabels.REJECTED;
    pEle.innerHTML = `${value} by ${currentUserData.name} ${this._config.formatDateTime(new Date())}`
  }

  getStatusMessage(templateDefinition) {
    const template = {
      tag: 'p',
      attributes: {
        'data-status-id': templateDefinition.children[0].attributes[CkeditorConstants.helperAttributes.DATA_COMMENT_ID],
        class: CkeditorConstants.class.ck_status,
        style: {
          display: CkeditorConstants.style.none
        }
      },
      children: []
    }
    return template;
  }

  isEditModeOn(templateDefinition) {
    this.editButton.on(CkeditorConstants.event.EXECUTE, () => {
      if (this.isEditMode) {
        //Approve, Reject, Resolve buttons are disabled when comment is in edit mode
        templateDefinition.children[2].children.forEach((btnView) => {
          btnView.isEnabled = false;
        });
        const commentEditMode = templateDefinition.children[1].children[1].children[2].children._items[0];

        commentEditMode.submitButtonView.withText = true;
        commentEditMode.submitButtonView.label = CkeditorConstants.commentLabels.POST;
        commentEditMode.submitButtonView._tooltipString = CkeditorConstants.commentLabels.POST_COMMENT;

        commentEditMode.cancelButtonView.withText = true;
        commentEditMode.cancelButtonView.label = CkeditorConstants.commentLabels.CANCEL;
        commentEditMode.cancelButtonView._tooltipString = CkeditorConstants.commentLabels.CANCEL;
        //Approve, Reject, Resolve buttons are enabled upon switching back to view only mode
        commentEditMode.submitButtonView.on(CkeditorConstants.event.EXECUTE, () => {
          templateDefinition.children[2].children.forEach((btnView) => {
            btnView.isEnabled = true;
          });
        });
        commentEditMode.cancelButtonView.on(CkeditorConstants.event.EXECUTE, () => {
          templateDefinition.children[2].children.forEach((btnView) => {
            btnView.isEnabled = true;
          });
        });
      }
    });
  }

  /**
   * Create edit and remove button views
   * @private
   * @returns {ButtonView[]}
   */
  _createEditAndRemoveButtonView() {
    const buttonUiConfig = [
      { icon: Edit, isEnable: true, tooltip: EDIT  },
      { icon: Delete, isEnable: true, tooltip: DELETE }
    ];

    const buttons = [];

    _.forEach(buttonUiConfig, (buttonConfig) => {
      const button = new ButtonView(this.locale);
      const t = this.locale.t;

      button.set({
        icon: buttonConfig.icon,
        class: ck_button + buttonConfig.tooltip,
        tooltip: t(buttonConfig.tooltip),
        withText: false,
        isEnabled: buttonConfig.isEnable
      });
      
      buttons.push(button);
    });

    return buttons;
  }
}
